import React from "react";

import API from "@beardeddevops/react.api";
import Framework from '@beardeddevops/react.framework';
import Types from "constants/Types";
import TransactionCollection from "components/TransactionCollection";
import TransactionType from "../../constants/TransactionTypes";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

export default class Rentals extends TransactionCollection {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_RENTALS';
		this.model.set = TransactionType.Rental;
	}

	render() {
		const {loading} = this.state;
		return (
			<Card>
				<CardContent>
					{super.render('Rentals', 'rentals', "Customer")}

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}